
import process from 'process/browser.js';
import { Buffer } from 'buffer';
import 'setimmediate'; // Production-ready polyfill for setImmediate


if (typeof window !== 'undefined') {
  
  window.process = window.process || process;
  window.global = window.global || window;
  window.Buffer = window.Buffer || Buffer;
  
 
  if (window.process && typeof window.process.env !== 'object') {
    window.process.env = {};
  }
}


export { process, Buffer };
